<template>
  <v-card class="rounded-sm" color="primary">
    <v-card-text>
      <v-form v-model="trayectoriaLaboralForm" ref="form">
        <v-container>
          <v-row no-gutters>
            <v-col cols="12">
              <BaseInput class="mb-1" v-model="editTrayectoriaLaboral.empresa" validate-on-blur>
                <template v-slot:label>Empresa</template>
              </BaseInput>
            </v-col>
            <v-col cols="12">
              <BaseInput v-model="editTrayectoriaLaboral.puesto" label="Puesto que desempeñó"></BaseInput>
            </v-col>
            <v-col cols="12">
              <BaseInput
                v-model="editTrayectoriaLaboral.periodo"
                label="Periodo que desempeñó sus funciones"
              ></BaseInput>
            </v-col>
            <v-col cols="12">
              <BaseInput v-model="editTrayectoriaLaboral.motivoConclusion" label="Motivo de Conclusión"></BaseInput>
            </v-col>
          </v-row>
        </v-container>
      </v-form>
    </v-card-text>
    <v-card-actions class="justify-center">
      <TextButton
        color="secondary"
        class="px-8"
        :disabled="!trayectoriaLaboralForm || loading"
        :loading="loading"
        @click="triggerUpdateTrayectoriaLaboral"
      >
        Guardar
      </TextButton>
    </v-card-actions>
  </v-card>
</template>

<script>
import { mapActions } from 'vuex'
import BaseInput from '@/components/base/BaseInput.vue'
import TextButton from '../../../base/TextButton.vue'

export default {
  components: {
    BaseInput,
    TextButton,
  },

  props: {
    trayectoriaLaboral: {
      type: Object,
      required: true,
    },
    idPersonal: {
      type: Number,
      required: true,
    },
  },

  data() {
    return {
      trayectoriaLaboralForm: false,
      loading: false,
      editTrayectoriaLaboral: { ...this.trayectoriaLaboral },
    }
  },

  watch: {
    trayectoriaLaboral: {
      handler(newVal) {
        this.editTrayectoriaLaboral = {
          ...newVal,
          fk_idPersonal: this.idPersonal,
        }
      },
      deep: true,
      immediate: true,
    },
  },

  methods: {
    ...mapActions('dialog', ['closeDialog']),
    ...mapActions('trayectoriaLaboral', ['update', 'fetchByPersonal']),

    async triggerUpdateTrayectoriaLaboral() {
      this.loading = true
      try {
        const id = this.editTrayectoriaLaboral.idTrayectoriaLaboral || this.editTrayectoriaLaboral.id
        await this.update({
          idTrayectoriaLaboral: id,
          payload: this.editTrayectoriaLaboral,
        })
        await this.fetchByPersonal(this.idPersonal)
        this.closeDialog()
      } catch (e) {
        console.error(e)
      } finally {
        this.loading = false
      }
    },

    resetForm() {
      if (this.$refs.form) this.$refs.form.resetValidation()
    },
  },
}
</script>
